module.exports = __webpack_public_path__ + "img/line.b5f9ceb0.svg";